import { render, staticRenderFns } from "./express-detail.vue?vue&type=template&id=4a9a225d&scoped=true"
import script from "./express-detail.vue?vue&type=script&lang=js"
export * from "./express-detail.vue?vue&type=script&lang=js"
import style0 from "./express-detail.vue?vue&type=style&index=0&id=4a9a225d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9a225d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a9a225d')) {
      api.createRecord('4a9a225d', component.options)
    } else {
      api.reload('4a9a225d', component.options)
    }
    module.hot.accept("./express-detail.vue?vue&type=template&id=4a9a225d&scoped=true", function () {
      api.rerender('4a9a225d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/task/components/components/express-detail.vue"
export default component.exports